module.exports = __webpack_public_path__ + "static/media/tree-decorated.03e72f69.svg";